'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { AppIcon, WORKSHOP_CATEGORIES } from '@impacta/shared';

const categories = ['Todas', ...WORKSHOP_CATEGORIES];
const priceRanges = [
  { label: 'Todos los precios', value: '' },
  { label: 'Hasta $20.000', value: '20000' },
  { label: 'Hasta $50.000', value: '50000' },
  { label: 'Hasta $100.000', value: '100000' },
  { label: 'Más de $100.000', value: '999999' },
];

export default function QuickSearch() {
  const [category, setCategory] = useState('Todas');
  const [maxPrice, setMaxPrice] = useState('');
  const router = useRouter();

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (category && category !== 'Todas') params.set('category', category);
    if (maxPrice) params.set('maxPrice', maxPrice);
    const query = params.toString();
    router?.push(query ? `/actividades?${query}` : '/actividades');
  };

  return (
    <section className="relative z-20 -mt-8 max-w-5xl mx-auto px-6 lg:px-8">
      <div
        className="rounded-2xl p-5 md:p-6"
        style={{
          background: 'white',
          boxShadow: '0 8px 40px rgba(55,58,54,0.14)',
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          {/* Category */}
          <div>
            <label
              htmlFor="quicksearch-category"
              className="block text-xs font-bold uppercase tracking-wider text-[#6b6e68] mb-2"
            >
              Categoría
            </label>
            <div className="relative">
              <select
                id="quicksearch-category"
                value={category}
                onChange={(e) => setCategory(e?.target?.value)}
                className="w-full appearance-none bg-[#FAFAF8] border border-[#E8E8E4] rounded-xl px-4 py-3 text-sm font-semibold text-[#373A36] focus:outline-none focus:border-[#00A19B] transition-colors"
              >
                {categories?.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <AppIcon
                name="ChevronDownIcon"
                size={16}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6b6e68] pointer-events-none"
              />
            </div>
          </div>

          {/* Price range */}
          <div>
            <label
              htmlFor="quicksearch-price"
              className="block text-xs font-bold uppercase tracking-wider text-[#6b6e68] mb-2"
            >
              Rango de precios
            </label>
            <div className="relative">
              <select
                id="quicksearch-price"
                value={maxPrice}
                onChange={(e) => setMaxPrice(e?.target?.value)}
                className="w-full appearance-none bg-[#FAFAF8] border border-[#E8E8E4] rounded-xl px-4 py-3 text-sm font-semibold text-[#373A36] focus:outline-none focus:border-[#00A19B] transition-colors"
              >
                {priceRanges?.map((p) => (
                  <option key={p?.value} value={p?.value}>
                    {p?.label}
                  </option>
                ))}
              </select>
              <AppIcon
                name="ChevronDownIcon"
                size={16}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6b6e68] pointer-events-none"
              />
            </div>
          </div>

          {/* Search Button */}
          <button
            onClick={handleSearch}
            className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-bold text-sm transition-all duration-200 bg-[#E0DF00] text-[#373A36] hover:bg-[#00A19B] hover:text-white"
          >
            <AppIcon name="MagnifyingGlassIcon" size={18} />
            Buscar actividades
          </button>
        </div>
      </div>
    </section>
  );
}
